window.VjsUtility = (function(my){
    my.extend = function(Parent, extObject){
        function Child() {
            Child.parent.constructor.apply(this, arguments);
            if (typeof this._construct === "function") {
                this._construct(arguments[0]);
            }
        }
        Child.prototype = inherit(Parent.prototype);
        Child.prototype.constructor = Child;
        Child.parent = Parent.prototype;
        Child = extendHelper(Child, extObject);
        return Child;
    }

    function extendHelper(Child, extObject) {
        for (var key in extObject) {
            Child.prototype[key] = extObject[key];
        }
        return Child;
    }

    function inherit(proto) {
        function F() {}
        F.prototype = proto;
        return new F();
    }

    return my;
}(window.VjsUtility || {}));
